import { createContext, useContext, useMemo, useState } from "react";
import { DICT } from "../i18n/dict";

const LanguageContext = createContext(null);

const STORAGE_KEY = "app.lang";

function detectInitial() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "km" || saved === "en") return saved;
  } catch {}
  return "km";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitial);

  const setLang = (next) => {
    setLangState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch {}
  };

  // t(kmText) looks up the English translation for a Khmer source string.
  // Falls back to the original text when no translation exists yet or when
  // lang is "km" — so wrapping a string that isn't in the dictionary never
  // breaks the UI, it just stays Khmer until someone adds the entry.
  const t = useMemo(() => {
    return (kmText) => {
      if (lang === "km" || kmText == null) return kmText;
      const hit = DICT[kmText];
      return hit != null ? hit : kmText;
    };
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext) ?? { lang: "km", setLang: () => {}, t: (s) => s };
}
